/** @jsxImportSource @emotion/react */

import { Spin } from "antd";
import PaginationTable from "components/desktop/PaginationTable";
import { OrderType } from "enums/orders";
import { generateDateRange } from "helpers/generateDateRange";
import { ItemTransaction } from "pages/desktop/Transaction/ItemTransaction/ItemTransaction";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUsername } from "store/auth";
import { selectDepositOrders, selectOrdersFilter } from "store/orders";
import { getMemberDepositOrders } from "store/orders/orders.thunk";
import { AppDispatch } from "types";

import Nodata from "../Nodata";
import { DepositTableStyle } from "./style.index";

interface State {
  page: number;
}

const PAGE_SIZE = 7;

const DepositTable = () => {
  const dispatch = useDispatch<AppDispatch>();
  const filter = useSelector(selectOrdersFilter);

  const {
    data: dataTransaction,
    isLoading,
    total,
  } = useSelector(selectDepositOrders);

  const username =
    useSelector(selectUsername) || localStorage.getItem("username") || "";

  const [state, setState] = useState<State>({
    page: 1,
  });

  useEffect(() => {
    dispatch(
      getMemberDepositOrders({
        username: username,
        page: state.page,
        size: PAGE_SIZE,
        ...generateDateRange(filter),
      }),
    );
  }, [state.page, filter]);

  const renderList = () => {
    if (isLoading) {
      return (
        <div css={DepositTableStyle.loadingData}>
          {Array.from(Array(1), (_, index) => (
            <React.Fragment key={index}>
              <Spin />
              <span style={{ color: "white" }} key={index}>
                Đọc dữ liệu...
              </span>
            </React.Fragment>
          ))}
        </div>
      );
    }

    if (!dataTransaction?.length) {
      return <Nodata />;
    }

    return (
      <div>
        {dataTransaction.map((item, index) => {
          return (
            <ItemTransaction
              key={`key-${index}-item-transaction`}
              title={item.transaction_code}
              createdDate={item.create_date}
              amount={item.amount}
              status={Number(item.status)}
              type={Number(item.type)}
              orderType={OrderType.DEPOSIT}
            />
          );
        })}
      </div>
    );
  };

  return (
    <div>
      {renderList()}
      {!isLoading && (
        <PaginationTable
          lengthData={dataTransaction?.length || 0}
          page={state.page}
          pageSize={PAGE_SIZE}
          total={total}
          onChangePage={(page: number) => setState({ page })}
        />
      )}
    </div>
  );
};

export default DepositTable;
